// Item-table columns a typer is allowed to see.
// MUST mirror config/typer.php `visible_columns` in the backend.
export const TYPER_VISIBLE_COLUMNS = ['image', 'name', 'colors', 'categories', 'posted_at', 'static', 'ai_threshold', 'number', 'description', 'note', 'brands'];

export default TYPER_VISIBLE_COLUMNS;
